import React from 'react';
import { ReactComponent as ListAlt } from '../../assets/images/icons/list-all-menu.svg';

export default function ListAlMenuIcon(props) {
  return (
    <ListAlt {...props} className={'icon'} />
  );
}
